// api/services/plugins.ts
import type { EndpointsRegistry, FetchClient } from '~/api/types'
import { GatewayEndpoints } from '~/api/endpoints/gateway-endpoints'

// The raw JSON shape returned by GET /api/plugins — matches backend PluginResponse DTO exactly.
export interface PluginApiResponse {
  id: string
  name: string // slug, e.g. 'traffic'
  label: string // display name, e.g. 'Traffic'
  version: string
  status: string // 'active' | 'inactive'
  enabled: boolean // derived: status === 'active'
  hasUI: boolean // derived: ui_bundle_path !== ''
  ui_path: string // gateway-relative UI path, e.g. /api/plugins/{id}/ui/
  api_path: string // gateway-relative API path, e.g. /api/plugins/{id}/api/
  last_heartbeat_at: string | null
  // Metadata fields — null when no plugin_metadata row exists yet
  publisher: string | null
  description: string | null
  category: string | null // 'Integrations' or null
  nextVersion: string | null
  hasUpdate: boolean
  iconBg: string | null
  iconColor: string | null
  icon: string | null
}

export interface PluginsService {
  getAll: () => Promise<PluginApiResponse[]>
  mintUIToken: (pluginId: string) => Promise<{ ui_token: string }>
}

export const registerEndpoints = (client: FetchClient, registry: EndpointsRegistry): PluginsService => {
  return {
    getAll: async (): Promise<PluginApiResponse[]> => {
      const { url, method, headers } = registry.createRequest(GatewayEndpoints.PLUGINS_GET_ALL)
      return await client<PluginApiResponse[]>(url, { method, headers })
    },

    mintUIToken: async (pluginId: string): Promise<{ ui_token: string }> => {
      const { url, method, headers } = registry.createRequest(GatewayEndpoints.PLUGIN_UI_TOKEN_POST, {
        params: { pluginId }
      })
      return await client<{ ui_token: string }>(url, { method, headers })
    }
  }
}
